import css from 'styled-jsx/css';

const styles = css.global`#santander-header {
  width: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

#fixed-spacer {
  width: 100%;
  height: 58px;
}

.wrapper,
.wrapper-mb {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 80px;
}

.wrapper-mb {
  height: 58px;
}

.search-input {
  border: none;
  color: #444444;
  outline: none;
  padding: 0;
  padding-right: 40px;
  width: 100%;
  height: 100%;
  font-weight: 600;
  box-sizing: border-box;
  margin-top: 3px;
}

.search-input::placeholder {
  font-weight: 600;
}

.search-container {
  flex: 1;
  margin: 0 40px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  border-bottom: 3px solid #cccccc;

  display: flex;
  align-items: center;
  justify-content: flex-start;
}

#icone-lupa {
  position: absolute;
  top: calc(50% - 6px);
  right: 0;
  transform: translate(-50%, 0);
}

.wrapper.desktop {
  display: none;
}

.wrapper-mb.mobile {
  display: flex;
}

.row-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#santander-sidebar {
  width: 100%;
  top: 58px;
  height: calc(100vh - 58px);
  max-width: 100vw;
  background: #fff;
  border-top: 1px solid #767676;
}

#santander-sidebar a {
  text-decoration: none;
}

.amp-sidebar-mask {
  display: none;
}

.sidebar-wrapper {
  margin: 0;
  padding: 0 15px;
}

.sidebar-wrapper p {
  margin: 22px 8px 6px 8px;
  color: #000;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 175% */
}

.sidebar-item-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  padding: 15px 8px;
  border-bottom: 1px solid #767676;

  margin: 6px 0;
  position: relative;
}

.sidebar-item-container span,
.sidebar-item-container > a {
  margin: 0;
  color: #000;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "SantanderText";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */
}

.sidebar-item-container a+img{
  position: absolute;
  right: 9px;
  pointer-events: none;
}

.sidebar-item-container .flag-destaque {
  background-color: #609E55;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  font-size: 13px;
  padding: 4px 5px;
  line-height: 15px;
  text-align: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-start span {
  margin-left: 16px;
}

.login-mb {
  /* height: 24px;
  width: 24px;*/
  position: relative; 
  /* margin-left: 16px; */
  color: #ec0000;
  font-family: 'SantanderHeadline';
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

@media (max-width: 320px) {
  .login-mb {
    font-size: 14px;
  }
}

#santander-header a {
  text-decoration: none;
}

#search-mobile {
  display: flex;
}

.wrapper-mb.mobile.hide-header {
  display: none;
}

@media (min-width: 992px) {
  #search-mobile {
    display: none;
  }
  .wrapper.desktop {
    display: flex;
  }

  .wrapper-mb.mobile {
    display: none;
  }

  #fixed-spacer {
    height: 140px;
  }
}

/* .search-container,
#icone-lupa-mobile {
  visibility: hidden;
} */

#icone-lupa-mobile {
  /* display: none; */
  margin-right: 10px;
}

.container-mobile-header {
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 1027px;
}

.sidebar-item-container > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.sidebar-item-container a.text-red {
  color: #c00;
}

.sidebar-ampless {
  font-family: 'Open Sans';
  position: fixed;
  top: 0;
  max-height: 100vh;
  height: 100vh;
  max-width: 80vw;
  background-color: #efefef;
  min-width: 45px;
  outline: none;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2147483647;
  -webkit-overflow-scrolling: touch;
  will-change: transform;
  left: -100%;

  transition: left 0.233s cubic-bezier(0, 0, 0.21, 1);
}

.sidebar-ampless.opened {
  left: 0;
}

.nested-menu-ampless {
  transition: transform 0.233s cubic-bezier(0, 0, 0.21, 1);
  transform: translateX(0);
}

.nested-menu-ampless.opened {
  transform: translateX(-100%);
}

.sidebar-ampless .nested-submenu-ampless {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 200%;
  overflow: visible;
  transition: left 0.233s cubic-bezier(0, 0, 0.21, 1);
}

.sidebar-ampless .nested-submenu-ampless.opened {
  display: block;
  left: 100%;
}

.sidebar-ampless .nested-menu-ampless > ul.sidebar-wrapper,
.sidebar-ampless .nested-submenu-ampless.opened .sidebar-wrapper.sub-sidebar {
  padding-right: 0;
  padding-left: 0;
}

.sidebar-ampless .nested-menu-ampless.opened > ul.sidebar-wrapper,
.sidebar-ampless.opened .sidebar-wrapper {
  padding-right: 15px;
  padding-left: 15px;
}

.sidebar-ampless .go-back {
  margin-top: 0;
}

.sidebar-ampless ul {
  list-style-type: none;
}

#abra-sua-conta-header-desktop{
  margin-left: 20px;
}

.sidebar-display-visible {
  display: block;
}

.sidebar-display-hidden {
  display: none;
}
`;

export default styles;